export default __webpack_public_path__ + "static/media/IC00037-favorite.6cb24021.svg";